import { HOURS_IN_DAY, MINUTES_IN_HOUR } from '../../../../../common/constants/date-config';

export const ONE_SLOT_PXS_WIDTH = 200;
export const ONE_SLOT_PXS_HEIGHT = 8;
export const ONE_SLOT_MINUTES = 15;
export const SLOTS_IN_HOUR = MINUTES_IN_HOUR / ONE_SLOT_MINUTES;
export const SLOTS_IN_DAY = HOURS_IN_DAY * SLOTS_IN_HOUR;
export const ONE_HOUR_PXS_HEIGHT = ONE_SLOT_PXS_HEIGHT * SLOTS_IN_HOUR;

export enum CalendarZoomType {
  In = 'IN',
  Out = 'OUT',
}

export const CALENDAR_ZOOM_FACTORS: number[] = [1, 2, 4, 8, 16];

export enum CoordinatesAxis {
  X = 'X',
  Y = 'Y',
}
